document.addEventListener('DOMContentLoaded', function () {
  var form = document.getElementById('supplier-return-form');
  if (!form) return; // Do nothing on other pages

  var maxRows = 10;
  var rowsEl = document.getElementById('rfRows');
  var addBtn = document.getElementById('addRowBtn');
  var grandEl = document.getElementById('grandTotal');
  var summaryEl = document.getElementById('ItemsSummary');
  var grandField = document.getElementById('GrandTotalField');
  var previewBtn = document.getElementById('previewPdfBtn');

  // --- Unique Request ID ---
  function genRequestId() {
    var d = new Date();
    var pad = function (n) { return String(n).padStart(2, '0'); };
    var y = d.getFullYear();
    var m = pad(d.getMonth() + 1);
    var day = pad(d.getDate());
    var h = pad(d.getHours());
    var mi = pad(d.getMinutes());
    var s = pad(d.getSeconds());
    var ms = String(d.getTime()).slice(-3);
    var rand = Math.random().toString(36).slice(2, 5).toUpperCase();
    return 'PR-' + y + m + day + '-' + h + mi + s + ms + '-' + rand;
  }

  var requestId = genRequestId();
  var reqIdInput = document.getElementById('ContactReqId');
  if (reqIdInput) reqIdInput.value = requestId;

  // --- Supplier "Other" toggle ---
  var supplierSel = document.getElementById('ContactSupplier');
  var supplierOtherWrap = document.getElementById('SupplierOtherWrap');
  var supplierOtherInput = document.getElementById('ContactSupplierOther');

  if (supplierSel) {
    supplierSel.addEventListener('change', function () {
      var isOther = supplierSel.value === 'Other';
      if (supplierOtherWrap) supplierOtherWrap.style.display = isOther ? 'block' : 'none';
      if (!isOther && supplierOtherInput) supplierOtherInput.value = '';
    });
  }

  // --- Reason codes ---
  var reasons = [
    "Scratched - Hairline",
    "Scratched - Bad Scratches",
    "Defective Lens or Lenses",
    "Loose or Missing Hinge Screw",
    "Misaligned Temples (Wider than comparative models)",
    "Bent Temples or Frame",
    "Scuffed Frame",
    "Received a return",
    "Received a used item",
    "Other"
  ];

  function money(n) {
    var v = parseFloat(n);
    if (!isFinite(v)) v = 0;
    return v.toFixed(2);
  }

  function reasonSelect(index) {
    var html = '<div class="rf-reason-wrap">';
    html += '<select name="contact[Item ' + (index + 1) + ' - Reason]" class="rf-select reason-select">';
    html += '<option value="">Select reason…</option>';
    reasons.forEach(function (r) {
      html += '<option value="' + r + '">' + r + '</option>';
    });
    html += '</select>';
    html += '<textarea class="rf-input rf-other" name="contact[Item ' + (index + 1) + ' - Other notes]" rows="2" placeholder="Please provide details"></textarea>';
    html += '<input type="text" class="rf-input rf-comment" name="contact[Item ' + (index + 1) + ' - Comments]" placeholder="Comments (optional)">';
    html += '</div>';
    return html;
  }

  function proceedSelect(index) {
    var html = '';
    html += '<select class="rf-select rf-proceed" name="contact[Item ' + (index + 1) + ' - Proceed]">';
    html += '<option value="">—</option>';
    html += '<option value="Replacement">Replacement</option>';
    html += '<option value="Full Credit">Full Credit</option>';
    html += '<option value="Partial Credit">Partial Credit</option>';
    html += '</select>';
    return html;
  }

  function rowTemplate(index) {
    var html = '';
    html += '<div class="rf-row" data-index="' + index + '">';
    html += '<input type="text" name="contact[Item ' + (index + 1) + ' - Product]" placeholder="e.g., WMP Aviator Gold 58mm">';
    html += '<input type="number" name="contact[Item ' + (index + 1) + ' - Qty]" min="1" value="1">';
    html += '<input type="number" step="0.01" name="contact[Item ' + (index + 1) + ' - Cost]" placeholder="0.00">';
    html += '<input type="text" name="contact[Item ' + (index + 1) + ' - Line total]" value="0.00" readonly>';
    html += reasonSelect(index);
    html += proceedSelect(index);
    html += '<button type="button" class="rf-rem" aria-label="Remove item">Remove</button>';
    html += '</div>';
    return html;
  }

  function calcTotals() {
    var grand = 0;
    var rows = rowsEl.querySelectorAll('.rf-row');

    rows.forEach(function (row) {
      var qtyInput = row.querySelector('input[name$=" - Qty]"]');
      var costInput = row.querySelector('input[name$=" - Cost]"]');
      var lineInput = row.querySelector('input[name$=" - Line total]"]');

      var qty = qtyInput ? parseFloat(qtyInput.value) || 0 : 0;
      var cost = costInput ? parseFloat(costInput.value) || 0 : 0;
      var line = qty * cost;

      if (lineInput) lineInput.value = money(line);
      grand += line;
    });

    if (grandEl) grandEl.textContent = money(grand);
    if (grandField) grandField.value = '£' + money(grand);

    // Build summary text for the Shopify email
    if (summaryEl) {
      var lines = [];
      lines.push('Request ID: ' + requestId);

      rows.forEach(function (row, idx) {
        var prod = row.querySelector('input[name$=" - Product]"]');
        var qtyInput = row.querySelector('input[name$=" - Qty]"]');
        var costInput = row.querySelector('input[name$=" - Cost]"]');
        var lineInput = row.querySelector('input[name$=" - Line total]"]');
        var reasonSel = row.querySelector('.reason-select');
        var otherBox = row.querySelector('.rf-other');
        var commentEl = row.querySelector('.rf-comment');
        var proceedSel = row.querySelector('.rf-proceed');

        var prodVal = prod ? prod.value.trim() : '';
        var qtyVal = qtyInput ? qtyInput.value : '';
        var costVal = costInput ? costInput.value : '';
        var lineVal = lineInput ? lineInput.value : '';

        var reason = reasonSel ? (reasonSel.value || '') : '';
        var other = otherBox ? (otherBox.value || '').trim() : '';
        var reasonNote = (reason === 'Other' && other) ? ('Other: ' + other) : reason;

        var proceed = proceedSel ? (proceedSel.value || '') : '';
        var comment = commentEl ? (commentEl.value || '').trim() : '';

        // Skip if *everything* is blank
        if (!prodVal && !qtyVal && !costVal && !reasonNote && !proceed && !comment) return;

        var label = prodVal || ('Item ' + (idx + 1));
        var lineStr = (idx + 1) + '. ' + label;

        if (qtyVal) lineStr += ' — Qty: ' + qtyVal;
        if (costVal) lineStr += ' × £' + money(costVal);
        if (lineVal) lineStr += ' = £' + money(lineVal);
        if (reasonNote) lineStr += ' | Reason: ' + reasonNote;
        if (proceed) lineStr += ' | Proceed: ' + proceed;
        if (comment) lineStr += ' | Comments: ' + comment;

        lines.push(lineStr);
      });

      summaryEl.value = lines.join('\n');
    }
  }

  function addRow() {
    if (!rowsEl) return;
    var count = rowsEl.querySelectorAll('.rf-row').length;
    if (count >= maxRows) return;

    rowsEl.insertAdjacentHTML('beforeend', rowTemplate(count));
    toggleAddButton();
    calcTotals();
  }

  function removeRow(btn) {
    var row = btn.closest('.rf-row');
    if (!row) return;
    row.remove();
    toggleAddButton();
    calcTotals();
  }

  function toggleAddButton() {
    if (!addBtn || !rowsEl) return;
    var count = rowsEl.querySelectorAll('.rf-row').length;
    addBtn.disabled = count >= maxRows;
  }

  function buildSummaryHTML() {
    var requestedBy = (document.getElementById('ContactRequestedBy') || {}).value || '';
    var supplierVal = (document.getElementById('ContactSupplier') || {}).value || '';
    var supplierOtherVal = (document.getElementById('ContactSupplierOther') || {}).value || '';
    var supplier = supplierVal === 'Other' ? (supplierOtherVal || 'Other') : (supplierVal || '—');

    var email = (document.getElementById('ContactEmail') || {}).value || '';
    var type = (document.getElementById('ContactType') || {}).value || '';
    var ref = (document.getElementById('ContactRef') || {}).value || '';
    var grand = grandEl ? grandEl.textContent : '0.00';

    var rows = [];
    if (rowsEl) {
      rowsEl.querySelectorAll('.rf-row').forEach(function (row, idx) {
        var prod = row.querySelector('input[name$=" - Product]"]');
        var qtyInput = row.querySelector('input[name$=" - Qty]"]');
        var costInput = row.querySelector('input[name$=" - Cost]"]');
        var lineInput = row.querySelector('input[name$=" - Line total]"]');
        var reasonSel = row.querySelector('.reason-select');
        var otherBox = row.querySelector('.rf-other');
        var commentEl = row.querySelector('.rf-comment');
        var proceedSel = row.querySelector('.rf-proceed');

        var prodVal = prod ? prod.value.trim() : '';
        var qtyVal = qtyInput ? qtyInput.value : '';
        var costVal = costInput ? costInput.value : '';
        var lineVal = lineInput ? lineInput.value : '';

        var reason = reasonSel ? (reasonSel.value || '') : '';
        var other = otherBox ? (otherBox.value || '').trim() : '';
        var reasonNote = (reason === 'Other' && other) ? ('Other: ' + other) : reason;

        var proceed = proceedSel ? (proceedSel.value || '') : '';
        var comment = commentEl ? (commentEl.value || '').trim() : '';

        if (!prodVal && !qtyVal && !costVal && !reasonNote && !proceed && !comment) return;

        rows.push({
          label: prodVal || ('Item ' + (idx + 1)),
          qty: qtyVal || '0',
          cost: costVal || '0.00',
          total: lineVal || '0.00',
          reason: reasonNote,
          proceed: proceed || '—',
          comment: comment || '—'
        });
      });
    }

    var logo = "https://cdn.shopify.com/s/files/1/0778/6650/0436/files/PUNCH-logo-email-template.png?v=1762615101";

    var rowsHtml = rows.map(function (r, i) {
      return (
        '<tr>' +
          '<td>' + (i + 1) + '. ' + r.label + '</td>' +
          '<td style="text-align:center;">' + r.qty + '</td>' +
          '<td style="text-align:right;">£' + money(r.cost) + '</td>' +
          '<td style="text-align:right;">£' + money(r.total) + '</td>' +
          '<td>' + (r.reason || '&nbsp;') + '</td>' +
          '<td>' + r.proceed + '</td>' +
          '<td>' + r.comment + '</td>' +
        '</tr>'
      );
    }).join('');

    var html =
      '<!doctype html><html><head><meta charset="utf-8"><title>PUNCH Return/Credit</title>' +
      '<style>' +
        'body{font-family:Arial,sans-serif;padding:20px;background:#fff;color:#111;}' +
        'table{width:100%;border-collapse:collapse;margin-top:12px;}' +
        'th,td{border:1px solid #ddd;padding:8px;text-align:left;}' +
        'th{background:#f6f6f6;}' +
        '.banner{text-align:center;background:#000;padding:12px;border-radius:8px;}' +
        '.banner img{max-width:130px;}' +
        '.total{text-align:right;margin-top:10px;font-weight:bold;}' +
        '.note{background:#fff5f5;border:1px solid #fecaca;color:#7f1d1d;border-radius:8px;padding:10px;margin-top:12px;}' +
      '</style></head><body>' +
      '<div class="banner"><img src="' + logo + '" alt="PUNCH"></div>' +
      '<h2>Product Return / Credit Form</h2>' +
      '<p>' +
        '<strong>Request ID:</strong> ' + requestId + '<br>' +
        '<strong>Requested by:</strong> ' + requestedBy + '<br>' +
        '<strong>Supplier:</strong> ' + supplier + '<br>' +
        '<strong>Email:</strong> ' + email + '<br>' +
        '<strong>Request type:</strong> ' + type + '<br>' +
        '<strong>Reference / PO:</strong> ' + ref + '<br>' +
        '<strong>Date:</strong> ' + new Date().toLocaleString() +
      '</p>' +
      '<table><thead><tr>' +
        '<th>Product</th><th>Qty</th><th>Cost</th><th>Line total</th><th>Reason</th><th>Proceed</th><th>Comments</th>' +
      '</tr></thead><tbody>' +
        (rowsHtml || '<tr><td colspan="7">No items added.</td></tr>') +
      '</tbody></table>' +
      '<div class="total">Grand total: £' + grand + '</div>' +
      '<div class="note">' +
        'If you are unable to replace any of the items, please issue a credit note instead.<br>' +
        'Items are available to return; if we do not receive instructions, items may be donated to charity or disposed of.<br>' +
        'Photo/video evidence available upon request.' +
      '</div>' +
      '</body></html>';

    return html;
  }

  function openPreview() {
    calcTotals();
    var html = buildSummaryHTML();
    var blob = new Blob([html], { type: 'text/html' });
    var url = URL.createObjectURL(blob);
    window.open(url, '_blank');
  }

  // --- Event bindings ---
  if (addBtn) {
    addBtn.addEventListener('click', addRow);
  }

  if (rowsEl) {
    rowsEl.addEventListener('input', function (e) {
      if (e.target.matches('input')) calcTotals();
    });

    rowsEl.addEventListener('change', function (e) {
      if (e.target.classList.contains('reason-select')) {
        var wrap = e.target.closest('.rf-reason-wrap');
        var otherBox = wrap ? wrap.querySelector('.rf-other') : null;
        if (otherBox) {
          if (e.target.value === 'Other') {
            otherBox.style.display = 'block';
          } else {
            otherBox.style.display = 'none';
            otherBox.value = '';
          }
        }
      }
      calcTotals();
    });

    rowsEl.addEventListener('click', function (e) {
      if (e.target.classList.contains('rf-rem')) {
        removeRow(e.target);
      }
    });
  }

  // Seed with two rows
  addRow();
  addRow();

  if (previewBtn) {
    previewBtn.addEventListener('click', openPreview);
  }
});
